import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const featureFlagsModule = createFrontendModule({
  pluginId: 'app',
  featureFlags: [
    {
      name: 'show-announcement-banner',
      description:
        'Exibe o banner de novos anúncios no topo da Home. Desative para uma visualização mais limpa.',
    },
    {
      name: 'homepage-activity-widgets',
      description:
        'Exibe os widgets de atividade recente (Recentes e Mais Visitados) na Home.',
    },
    {
      name: 'experimental-homepage-layout',
      description:
        'Ativa o layout experimental da Home com novos widgets. Pode conter instabilidades.',
    },
  ],
});
